<template>
  <section
    id="contact"
    ref="contactSection"
    class="scroll-mt-70px min-h-1044px py-112px lt-sm:min-h-auto lt-sm:py-88px bg-[#f8fbff] bg-[linear-gradient(180deg,rgba(255,255,255,0.68)_0%,rgba(248,251,255,0.70)_48%,rgba(248,251,255,0.18)_100%),url('/assets/img/figma/contact-bg.png')] bg-[length:auto,100%_auto] [background-position:0_0,center_bottom] bg-no-repeat transition-all duration-1000 ease-out"
    :class="[isContactVisible ? 'translate-y-0 opacity-100' : 'translate-y-50px opacity-0']"
    data-section
  >
    <div class="landing-container lt-sm:px-32px">
      <section-heading
        title="联系我们"
        description="无论您是物业公司还是社区运营团队，我们都期待与您沟通，共同探索物业管理数字化升级之路。"
      />

      <div
        class="gap-28px lt-sm:grid-cols-1 grid grid-cols-[minmax(280px,472fr)_minmax(360px,940fr)] items-start"
      >
        <aside class="gap-28px lt-sm:gap-0 grid min-w-0" aria-label="绘管家联系方式">
          <div
            class="min-h-279px rounded-16px border-#e6eef9 p-32px lt-sm:min-h-auto lt-sm:p-24px lt-sm:hidden border bg-white/95"
          >
            <h3
              class="pf-sc-semibold mb-20px font-s-24px text-#0f172a lt-sm:font-s-36px lt-sm:leading-[48px] m-0"
            >
              联系方式
            </h3>
            <ul class="gap-24px m-0 grid list-none p-0">
              <li class="gap-18px flex items-start">
                <img
                  class="h-42px w-42px lt-sm:h-64px lt-sm:w-64px"
                  src="/assets/img/contact-phone.svg"
                  alt=""
                  aria-hidden="true"
                />
                <div>
                  <small
                    class="pf-sc-regular mb-6px font-s-14px text-#64748b lt-sm:font-s-22px block"
                  >
                    联系电话
                  </small>
                  <a
                    class="pf-sc-semibold font-s-18px text-#1e293b lt-sm:font-s-28px lt-sm:leading-[40px] leading-[1.55]"
                    href="tel:4006007709"
                  >
                    400-600-7709
                  </a>
                </div>
              </li>
              <li class="gap-18px flex items-start">
                <img
                  class="h-42px w-42px lt-sm:h-64px lt-sm:w-64px"
                  src="/assets/img/contact-address.svg"
                  alt=""
                  aria-hidden="true"
                />
                <div>
                  <small
                    class="pf-sc-regular mb-6px font-s-14px text-#64748b lt-sm:font-s-22px block"
                  >
                    公司地址
                  </small>
                  <span
                    class="pf-sc-regular font-s-18px text-#1e293b lt-sm:font-s-28px lt-sm:leading-[40px] leading-[1.55] break-words"
                  >
                    海南省海口市美兰区西溪里商业街7号楼一楼
                  </span>
                </div>
              </li>
            </ul>
          </div>

          <a
            class="min-h-172px rounded-16px lt-sm:hidden bg-#0f67f8 p-32px after:right-28px after:bottom-24px after:h-92px after:w-92px after:border-9px after:border-b-18px lt-sm:min-h-auto lt-sm:p-24px relative grid overflow-hidden text-white shadow-[0_18px_42px_rgba(15,103,248,0.24)] after:pointer-events-none after:absolute after:rounded-[50%_50%_18px_18px] after:border-white/12 after:opacity-75 after:content-['']"
            href="tel:4006007709"
            aria-label="拨打绘管家免费咨询电话 400-600-7709"
          >
            <strong
              class="pf-sc-semibold font-s-24px lt-sm:font-s-36px lt-sm:leading-[48px] relative z-1 text-white"
            >
              免费咨询服务
            </strong>
            <span
              class="pf-sc-regular mt-12px font-s-16px lt-sm:font-s-24px lt-sm:leading-[40px] relative z-1 leading-[1.7] break-words text-white/86"
            >
              我们为新客户提供首次 30
              分钟的免费行业解决方案咨询。点击下方按钮即可立即预约您的专属顾问。
            </span>
          </a>
        </aside>

        <form
          class="min-h-678px rounded-16px border-#e6eef9 p-40px lt-sm:min-h-auto lt-sm:p-28px w-full min-w-0 border bg-white/96 shadow-[0_24px_80px_rgba(15,103,248,0.13)]"
          novalidate
          @submit.prevent="emit('submit')"
        >
          <h3
            class="pf-sc-semibold mb-20px font-s-24px text-#0f172a lt-sm:font-s-36px lt-sm:leading-[48px] m-0"
          >
            给我们留言
          </h3>
          <p
            class="pf-sc-regular mb-24px font-s-16px text-#64748b lt-sm:font-s-24px lt-sm:leading-[40px] m-0 leading-[1.75] break-words"
          >
            填写下方表格，我们的专属顾问会尽快为您提供支持。
          </p>

          <div
            class="gap-24px lt-sm:grid-cols-1 lt-sm:gap-0 grid grid-cols-[repeat(2,minmax(0,1fr))]"
          >
            <label class="mb-22px gap-10px grid">
              <span class="pf-sc-semibold font-s-14px text-#0f172a lt-sm:font-s-22px">
                您的姓名
              </span>
              <input
                name="name"
                type="text"
                class="h-48px rounded-8px px-14px font-s-15px text-#1e293b placeholder:text-#94a3b8 lt-sm:h-72px lt-sm:font-s-24px w-full border bg-white transition-all duration-200 outline-none focus:shadow-[0_0_0_4px_rgba(15,103,248,0.1)]"
                :class="
                  contactsError
                    ? 'border-#dc2626 focus:border-#dc2626'
                    : 'border-#e2e8f0 focus:border-#0f67f8'
                "
                :value="contacts"
                placeholder="请输入姓名"
                autocomplete="name"
                required
                aria-describedby="contact-form-message"
                :aria-invalid="contactsError ? 'true' : undefined"
                @input="handleContactsInput"
              />
            </label>

            <label class="mb-22px gap-10px grid">
              <span class="pf-sc-semibold font-s-14px text-#0f172a lt-sm:font-s-22px">
                联系电话
              </span>
              <input
                name="phone"
                type="tel"
                class="h-48px rounded-8px px-14px font-s-15px text-#1e293b placeholder:text-#94a3b8 lt-sm:h-72px lt-sm:font-s-24px w-full border bg-white transition-all duration-200 outline-none focus:shadow-[0_0_0_4px_rgba(15,103,248,0.1)]"
                :class="
                  phoneError
                    ? 'border-#dc2626 focus:border-#dc2626'
                    : 'border-#e2e8f0 focus:border-#0f67f8'
                "
                :value="phone"
                placeholder="请输入手机号码"
                autocomplete="tel"
                required
                aria-describedby="contact-form-message"
                :aria-invalid="phoneError ? 'true' : undefined"
                @input="handlePhoneInput"
              />
            </label>
          </div>

          <label class="mb-22px gap-10px grid">
            <span class="pf-sc-semibold font-s-14px text-#0f172a lt-sm:font-s-22px">
              公司/社区名称
            </span>
            <input
              name="company"
              type="text"
              class="h-48px rounded-8px px-14px font-s-15px text-#1e293b placeholder:text-#94a3b8 lt-sm:h-72px lt-sm:font-s-24px w-full border bg-white transition-all duration-200 outline-none focus:shadow-[0_0_0_4px_rgba(15,103,248,0.1)]"
              :class="
                companyError
                  ? 'border-#dc2626 focus:border-#dc2626'
                  : 'border-#e2e8f0 focus:border-#0f67f8'
              "
              :value="company"
              placeholder="请输入单位全称"
              required
              aria-describedby="contact-form-message"
              :aria-invalid="companyError ? 'true' : undefined"
              @input="handleCompanyInput"
            />
          </label>

          <label class="mb-22px gap-10px grid">
            <span class="pf-sc-semibold font-s-14px text-#0f172a lt-sm:font-s-22px">留言内容</span>
            <textarea
              name="message"
              rows="5"
              maxlength="300"
              class="min-h-150px rounded-8px border-#e2e8f0 px-14px py-14px font-s-15px text-#1e293b placeholder:text-#94a3b8 focus:border-#0f67f8 lt-sm:min-h-220px lt-sm:font-s-24px w-full resize-y border bg-white transition-all duration-200 outline-none focus:shadow-[0_0_0_4px_rgba(15,103,248,0.1)]"
              placeholder="请详细描述您的需求或问题..."
              :value="message"
              @input="handleMessageInput"
            ></textarea>
          </label>

          <div class="flex flex-col items-end">
            <button
              class="pf-sc-semibold min-h-56px w-160px gap-10px rounded-12px bg-#0f67f8 font-s-15px hover:-translate-y-1px hover:bg-#0756d8 lt-sm:min-h-84px lt-sm:w-full lt-sm:font-s-28px inline-flex items-center justify-center border-0 text-white transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-70"
              type="submit"
              :disabled="submitting"
              :aria-busy="submitting ? 'true' : undefined"
            >
              {{ submitting ? '提交中...' : '提交留言' }}
              <i class="wh-18px i-custom-plane" alt="" aria-hidden="true"></i>
            </button>
            <p
              id="contact-form-message"
              class="pf-sc-regular mt-16px min-h-22px font-s-14px lt-sm:font-s-22px m-0"
              :class="
                formMessageType === 'error'
                  ? 'text-#dc2626'
                  : formMessageType === 'success'
                    ? 'text-#15803d'
                    : 'text-#0f67f8'
              "
              role="status"
              aria-live="polite"
            >
              {{ formMessage }}
            </p>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import SectionHeading from '../section-heading.vue'

  defineOptions({
    name: 'ContactSection',
  })

  defineProps<{
    company: string
    companyError: boolean
    contacts: string
    contactsError: boolean
    formMessage: string
    formMessageType: '' | 'error' | 'success'
    message: string
    phone: string
    phoneError: boolean
    submitting: boolean
  }>()

  const emit = defineEmits<{
    'clear-company-error': []
    'clear-contacts-error': []
    'clear-phone-error': []
    submit: []
    'update:company': [value: string]
    'update:contacts': [value: string]
    'update:message': [value: string]
    'update:phone': [value: string]
  }>()

  const contactSection = useTemplateRef<HTMLElement>('contactSection')
  const { isVisible: isContactVisible } = useScrollReveal(contactSection)

  const handleContactsInput = (event: Event) => {
    emit('update:contacts', (event.target as HTMLInputElement).value)
    emit('clear-contacts-error')
  }

  const handlePhoneInput = (event: Event) => {
    emit('update:phone', (event.target as HTMLInputElement).value)
    emit('clear-phone-error')
  }

  const handleCompanyInput = (event: Event) => {
    emit('update:company', (event.target as HTMLInputElement).value)
    emit('clear-company-error')
  }

  const handleMessageInput = (event: Event) => {
    emit('update:message', (event.target as HTMLTextAreaElement).value)
  }
</script>
